import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    root: {
        padding: 20
    },
    content: {
        textAlign: 'center',
        paddingBottom: 20
    },
    message: {
        textAlign: 'center'
    },
    rootNavigator: {
        paddingTop: 20,
        paddingBottom: 20
    },
    image: {
        maxWidth: 100
    },
    imageTitle: {
        textAlign: 'center',
        paddingLeft: 20
    }
}))
